import StateOffcanvas from '../Offcanvas'
import NamedCheckbox from '../NamedCheckbox'
import { GroupSelect } from 'GroupSelect'
import { useSettings } from 'Settings'
import SpinButton from 'SpinButton'
import Help from 'Help';

export function GreenPanel({ handle, onHide}) {
	const [settings] = useSettings()
	const vsup = settings['vsup']

	const disabled_behavior = [
		{ value : 0, label : "Floating" },
		{ value : 1, label : "GND" }
	]

	const inital_state = [
		{ value : 0, label : "Running" },
		{ value : 1, label : "Sleeping"},
	]

	return (
		<StateOffcanvas handle={handle} onHide={onHide} trigger="green" title="VSUP Settings">
			<div className="d-flex">
				<GroupSelect
					name="Behaviour when disabled"
					options={disabled_behavior}
					value={vsup['behaviour when disabled'].value}
					onChange={(v) => vsup['behaviour when disabled'].setValue(v.value)}
				/>
			</div>
			<NamedCheckbox
				name="Force enable"
				value={vsup['force enable'].value}
				onChange={(e) => vsup['force enable'].setValue(e.target.checked)}
			/>
			<GroupSelect
				name="Inital State"
				options={inital_state}
				value={vsup['initial state'].value}
				onChange={(v) => vsup['initial state'].setValue(v.value)}
			/>
			<SpinButton
				name="Sleep"
				value={vsup['sleep'].value}
				unit="ms"
				step="1"
				onChange={(e) => {
					if (e.target.value < 0) {
						e.target.value = 0
					} else if (e.target.value > 0xffffff) {
						e.target.value = 0xffffff
					}

					vsup['sleep'].setValue(e.target.value)
				}}
			/>
		</StateOffcanvas>
	)
}
